import { Card, Col, Row } from 'react-bootstrap'
import { Title } from '../../components/atoms/Title'
import { IBankStatementEntries } from '../../domain/usecases/BankStatementEntries'
import { IStandaloneBillings } from '../../domain/usecases/StandaloneBillings'
import { ConciliationTab } from './ConciliationTab'

// A aba "Cobranças Avulsas" saiu da tela em 23/10/2026 (ninguém usava). O componente
// continua em ./StandaloneBillingsTab; para voltar, é recolocar a aba aqui.
export interface ConciliationPageProps {
  standaloneBillings: IStandaloneBillings
  bankStatementEntries: IBankStatementEntries
}

export const ConciliationPage: React.FC<ConciliationPageProps> = ({
  standaloneBillings,
  bankStatementEntries
}) => (
  <Row>
    <Col md={12}>
      <Card>
        <Card.Header>
          <Title>Conciliação</Title>
        </Card.Header>
        <Card.Body>
          <ConciliationTab
            entriesService={bankStatementEntries}
            billingsService={standaloneBillings}
          />
        </Card.Body>
      </Card>
    </Col>
  </Row>
)

export default ConciliationPage
